import { NgModule } from '@angular/core';

import { RtiIntegrationsElementsDataModule } from '../integrations/rti-integrations-elements.module';

@NgModule({
  imports: [RtiIntegrationsElementsDataModule],
  exports: [],
})
export class IntegrationsClientModule {}

export * from './integrations-client.types';
export * from './components/integrations-element-outlet.component';
export * from './services/current-hotspot.token';
export * from './services/integration-kind.token';
export * from './services/contextual-integrations-api.service';
export * from './services/integrations-client-http.service';
export * from './services/integrations-elements.service';
export * from './services/partner.token';

export * from '../integrations/zoom/zoom-api';
export * from '../integrations/teams/teams-api';
export * from '../integrations/kununu/kununu-api';
export * from '../integrations/job-campaigns/job-campaigns';
export * from '../integrations/job-campaigns/types';
export * from '../integrations/oauth/oauth.service';
